<template>
    <div id='PendingNotificationList'>
        <div class="PendingNotificationHeader"><span>Pending Actions</span></div>
        <PendingNotificationItem v-for='(notification, idx) in notifications.slice().reverse()'
            :key='idx'
            :name='notification.message'
            :link='notification.link'
            :time='notification.timeStamp'
            :type='notification.type'
            :notificationObject='notification'
            @remove-notification = remove
        >
            
        </PendingNotificationItem>
        <div class='AllNotifications'>
            <button class='btn btn-primary btn-clear-all' @click="clearAll">Clear</button>
        </div>
    </div>
</template>
<script>
    import PendingNotificationItem from './PendingNotificationItem';
    export default{
        name: 'PendingotificationList',
        props:['notifications'],
        components:{
            PendingNotificationItem
        },
        /*created(){
            return {
                timeStarted: Date.now()
            }
        },*/
        data(){
            return{
                notificationList: this.$props.notifications,
                timeStarted: Date.now()
            }
        },
        methods:{
            remove(removedNotification){
                //console.log("button pressed: " +removedNotification )
                this.$store.dispatch('Navigation/removePendingNotification', removedNotification)
                .then(() => {
                    if(this.$props.notifications.length == 0){
                        this.$emit('re-enable-scroll');
                    }
                });
            },
            clearAll(){
                this.$props.notifications.forEach(notification => {
                    this.remove(notification);
                    this.$emit('re-enable-scroll');
                });
            }
        }
    }
</script>